import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../../core/et3-div";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import getKhattabat101MatchStore from "../../../../../../stores/khattabat-stores/101m-stores";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabat101MMessagingStore from "../../../../../../stores/khattabat-stores/101m-stores/101m-messaging-store";

const CloseOpenConversation = withLiteObserverAndTheme<{
  matchID: number;
}>((props) => {
  const { theme, matchID } = props;
  const { colors } = theme;
  const { conversationID } = getKhattabat101MatchStore(matchID);
  const isOpenedConversation =
    getKhattabatSharedMessagingStore(conversationID.get()).isOpened.get() ===
    "OPENED";

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={80}
      height={80}
      color={colors.all.transparent}
      style={{ cursor: "pointer" }}
      onClick={() =>
        getKhattabat101MMessagingStore(matchID).toggleConversationOpenState()
      }
    >
      <FontAwesomeIcon
        icon={!isOpenedConversation ? faChevronDown : faChevronUp}
        style={{ color: colors.all.blue }}
        size="3x"
      />
      <Et3Margin top={0} left={10} bottom={0} right={0} />
    </ET3Div>
  );
});
export default CloseOpenConversation;
